export enum EXPORT_TYPE {
  DOCX = "docx",
  PLAIN_TEXT = "plainText",
  PDF = "pdf",
  EMAIL = "email",
}

export enum REPORT_EXPORT_TYPE {
  DOCX = "docx",
  ASYNC_DOCX = "asyncDocx",
  ASYNC_DOCX_WITH_DOCLIST = "asyncDocxWithDoclist",
  PLAIN_TEXT = "plainText",
  PDF = "pdf",
  ASYNC_PDF = "asyncPdf",
  ASYNC_PDF_WITH_DOCLIST = "asyncPdfWithDoclist",
  EMAIL = "email",
}

export const REPORT_EXPORT_LIST = [
  {
    type: REPORT_EXPORT_TYPE.DOCX,
    label: "export.docx",
  },
  {
    type: REPORT_EXPORT_TYPE.ASYNC_DOCX,
    label: "export.docx",
  },
  {
    type: REPORT_EXPORT_TYPE.ASYNC_DOCX_WITH_DOCLIST,
    label: "export.docxWithDoclist",
  },
  {
    type: REPORT_EXPORT_TYPE.PLAIN_TEXT,
    label: "export.plainText",
  },
  {
    type: REPORT_EXPORT_TYPE.PDF,
    label: "export.pdf",
  },
  {
    type: REPORT_EXPORT_TYPE.ASYNC_PDF,
    label: "export.pdf",
  },
  {
    type: REPORT_EXPORT_TYPE.ASYNC_PDF_WITH_DOCLIST,
    label: "export.pdfWithDoclist",
  },
  {
    type: REPORT_EXPORT_TYPE.EMAIL,
    label: "export.email",
  },
];
export const EMAIL_EXPORT_MAX_CHARACTERS = 2000;
export const EXPORT_WITH_DOCLIST_MAX_PAGES = 1100;
export const MAX_MANUALLY_EXPANDED_SECTIONS = 2;

export enum DOCLIST_EXPORT_TYPE {
  FULL = "docListFull",
  TOC_PDF = "docListTocPdf",
  DOCX = "docListDocx",
  TOC_DOCX = "docListTocDocx",
}

export const EXPORT_LIST = [
  {
    type: EXPORT_TYPE.DOCX,
    label: "export.docx",
  },
  {
    type: EXPORT_TYPE.PLAIN_TEXT,
    label: "export.plainText",
  },
  {
    type: EXPORT_TYPE.PDF,
    label: "export.pdf",
  },
  {
    type: EXPORT_TYPE.EMAIL,
    label: "export.email",
  },
];

export const DOCLIST_EXPORT_LIST = [
  {
    type: DOCLIST_EXPORT_TYPE.FULL,
    label: "export.docList.full",
  },
  {
    type: DOCLIST_EXPORT_TYPE.TOC_PDF,
    label: "export.docList.tocPdf",
  },
  {
    type: DOCLIST_EXPORT_TYPE.DOCX,
    label: "export.docList.docx",
  },
  {
    type: DOCLIST_EXPORT_TYPE.TOC_DOCX,
    label: "export.docList.tocDocx",
  },
];
